import React from "react";
import { Loader2, Inbox } from "lucide-react";

export function Spinner({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-slate-500" data-testid="loading-spinner">
      <Loader2 className="h-8 w-8 animate-spin text-[#D4AF37]" />
      <p className="mt-3 text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ title, message, icon: Icon = Inbox, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-16 px-6 text-center" data-testid="empty-state">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#F5F3EF]">
        <Icon className="h-6 w-6 text-[#B8860B]" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-[#0B192C] font-head">{title}</h3>
      {message && <p className="mt-1.5 max-w-md text-sm text-slate-500">{message}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={center ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {eyebrow && <div className="label-eyebrow mb-3">{eyebrow}</div>}
      <h2 className="heading-2">{title}</h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-slate-500">{subtitle}</p>}
    </div>
  );
}

export function Pagination({ page, pages, onChange }) {
  if (pages <= 1) return null;
  return (
    <div className="mt-8 flex items-center justify-center gap-3" data-testid="pagination">
      <button
        className="btn-outline-navy px-4 py-2 text-xs disabled:opacity-40"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        data-testid="pagination-prev"
      >
        Previous
      </button>
      <span className="text-sm text-slate-600">
        Page {page} of {pages}
      </span>
      <button
        className="btn-outline-navy px-4 py-2 text-xs disabled:opacity-40"
        disabled={page >= pages}
        onClick={() => onChange(page + 1)}
        data-testid="pagination-next"
      >
        Next
      </button>
    </div>
  );
}

export function DemoBadge() {
  return <span className="demo-badge" title="Illustrative demo data">Demo</span>;
}
